import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { ButtonSize, ButtonMode, DropdownButton, MenuItem } from '../index';
export var PaginationButton = styled(Button).attrs(function (_ref) {
  var size = _ref.size,
      mode = _ref.mode;
  return {
    size: size || ButtonSize.X_SMALL,
    mode: mode || ButtonMode.OUTLINE
  };
}).withConfig({
  displayName: "styled__PaginationButton",
  componentId: "sc-1578de2-0"
})(function (_ref2) {
  var theme = _ref2.theme,
      selected = _ref2.selected;
  return css(["&&{border:1px solid ", ";padding:", ";border-radius:4px;height:32px;font-size:", ";font-weight:", ";line-height:", ";box-sizing:border-box;color:", ";", " & > *{padding:0;}&,&:hover,&:active,&:focus{text-decoration:none;}&:hover{border-color:", ";background:", ";color:", ";}&:active{border-color:", ";}&:disabled{opacity:0.6;}}"], theme.colors.grey.base, theme.space.xxxs + "px " + theme.space.xs + "px", theme.typography.variants.body.fontSize, theme.typography.variants.body.fontWeight, theme.typography.variants.body.lineHeight, theme.colors.secondary.base, selected && css(["background-color:", ";border-color:", ";color:white;"], theme.colors.primary.base, theme.colors.primary.base), selected ? theme.colors.primary.dark : theme.colors.grey.base, selected ? theme.colors.primary.dark : theme.colors.grey.light, selected ? 'white' : theme.colors.secondary.base, theme.colors.grey.darker);
});
export var ChevronButton = styled(PaginationButton).withConfig({
  displayName: "styled__ChevronButton",
  componentId: "sc-1578de2-1"
})(function (_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled;
  return css(["&&{padding:", ";", " & svg{width:16px;}}"], "0 " + theme.space.xxs + "px", disabled && "\n    color: " + theme.colors.secondary.lighter + ";\n    border-color: " + theme.colors.secondary.lighter + ";\n    ");
});
export var BorderlessPaginationButton = styled(PaginationButton).withConfig({
  displayName: "styled__BorderlessPaginationButton",
  componentId: "sc-1578de2-2"
})(["&&{border:none;cursor:default;background:transparent;&:hover{padding:", ";background:transparent;}}"], function (_ref4) {
  var space = _ref4.theme.space;
  return space.xxxs + "px " + space.xs + "px";
});
export var PageSizeDropdownBtn = styled(DropdownButton).withConfig({
  displayName: "styled__PageSizeDropdownBtn",
  componentId: "sc-1578de2-3"
})(function (_ref5) {
  var theme = _ref5.theme;
  return css(["background:transparent;height:32px;width:75px;border:1px solid ", ";border-radius:4px;padding:", ";display:flex;&:active{border-color:", ";}svg{width:16px;}& > div:last-child{display:flex;}"], theme.colors.grey.base, theme.space.xxxs + "px " + theme.space.xs + "px", theme.colors.grey.base);
});
export var StyledMenuItem = styled(MenuItem).withConfig({
  displayName: "styled__StyledMenuItem",
  componentId: "sc-1578de2-4"
})(["height:auto;"]);